import React from "react";

import "../../Styles/Comment.css";

const COmment = ({ name, text, img, imgSide }) => {
    return (
        <div className="Comment_wrapper">
            <img
                src={img}
                alt={`${name} Comment`}
                className={imgSide == "left" ? "left" : "right"}
            />
            <h5 style={{marginRight:"5px",fontWeight:"bold"}}>{name}</h5>
            <p>{text}</p>
        </div>
    );
};

export default COmment;
